import {
  GetAccessControlRawResponse,
  GetAccessControlResponse,
  UpdateAccessControlRawResponse,
  UpdateAccessControlResponse,
} from "./types";

export const transformAccessControl = (res: GetAccessControlRawResponse) => {
  const { _links, ...accessControl } = res;
  const response: GetAccessControlResponse = {
    data: {
      details: {
        enabledDriverSignup: Boolean(accessControl.enabled_driver_signup),
        enabledClientSignup: Boolean(accessControl.enabled_client_signup),
      },
    },
    links: _links,
  };

  return response;
};

export const transformUpdateAccessControl = (res: UpdateAccessControlRawResponse) => {
  return {
    links: res._links,
  } as UpdateAccessControlResponse;
};
